import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useChangeIframeStyle } from '../hooks/useChangeIframeStyle';
import { IFRAME_STYLE } from '../hooks/useChangeIframeStyle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnsupportedBrowserAlert = () => {
  useChangeIframeStyle(IFRAME_STYLE.POPOVER_ALERT);
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "400px",
    blockSize: "auto",
    backgroundColor: "fill-alert-subtle",
    borderColor: "border-alert-default",
    borderRadius: "100",
    borderWidth: "100",
    borderStyle: "solid",
    boxShadow: "300",
    padding: "400",
    as: "div",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      marginBlockEnd: "200",
      "data-selenium-test": "unsupported-calling-title",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calling-remote-app.thirdPartyCalling.alert.connectionUnsupported.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      "data-selenium-test": "unsupported-calling-message",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calling-remote-app.thirdPartyCalling.alert.connectionUnsupported.message"
      })
    })]
  });
};
export default UnsupportedBrowserAlert;